// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioItem_root__1hfUV","secondary":"RadioItem_secondary__unrva","active":"RadioItem_active__3pyAl"};